module.exports = __webpack_public_path__ + "img/MELA_pDC.45489aa5.png";